var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoArtbanneLongBlanc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2244.7 458.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{stroke-miterlimit:100;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke:#ceaa5b;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-7{fill:none;stroke-linecap:round;stroke-width:2px;}.cls-2{stroke-dasharray:0 0 1 6;}.cls-3{stroke-dasharray:0 0 1.04 6.21;}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke-miterlimit:10;}.cls-4{stroke-dasharray:0 0 1 6;}.cls-8{fill:#fff;}.cls-8,.cls-9{stroke-width:0px;}.cls-5{stroke-dasharray:0 0 .99 5.93;}.cls-9,.cls-6{fill:#ceaa5b;}.cls-6{stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 193.26,
    y1: 51.45,
    x2: 24.5,
    y2: 270.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 27.51,
    y1: 175.83,
    x2: 179.28,
    y2: 382.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 193.39,
    y1: 332.68,
    x2: 83.39,
    y2: 123.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 193.88,
    y1: 123.81,
    x2: 83.08,
    y2: 123.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 193.57,
    y1: 73.86,
    x2: 106.82,
    y2: 73.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 193.67,
    y1: 248.69,
    x2: 149.58,
    y2: 248.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 193.57,
    y1: 170.67,
    x2: 149.68,
    y2: 248.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 193.36,
    y1: 281.06,
    x2: 26.76,
    y2: 281.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 141.92,
    y1: 332.86,
    x2: 74.14,
    y2: 332.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 193.26,
    y1: 382.35,
    x2: 120.18,
    y2: 382.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 142.28,
    y1: 333.48,
    x2: 120.18,
    y2: 382.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 138.22,
    y1: 122.26,
    x2: 106.82,
    y2: 74.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 104.87,
    y1: 165.43,
    x2: 29.94,
    y2: 165.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 103.53,
    y1: 280.44,
    x2: 74.45,
    y2: 332.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 107.26,
    cy: 73.9,
    r: 4.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 74.6,
    cy: 333.22,
    r: 4.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 83.9,
    cy: 123.85,
    r: 4.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 120.47,
    cy: 382.47,
    r: 4.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 192.62,
    y1: 42.91,
    x2: 192.32,
    y2: 43.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.77,48.15l-13.03,17.71c-1.01,1.38-2.62,2.19-4.34,2.19l-68.25.26c-2.19,0-4.1,3.25-2.98,5.14l24.03,40.06c1.21,2.05-.28,4.63-2.65,4.62l-42.49-.25c-2.13-.01-3.6,3.32-2.62,5.21l18.17,33.96c.97,1.88-.39,4.12-2.51,4.13l-56,.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.09,
    y1: 161.32,
    x2: 32.59,
    y2: 161.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 106.36,
    y1: 165.43,
    x2: 106.86,
    y2: 165.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 113.07,
    y1: 165.43,
    x2: 189.68,
    y2: 165.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 192.79,
    y1: 165.43,
    x2: 193.29,
    y2: 165.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 192.57,
    y1: 124.01,
    x2: 192.32,
    y2: 124.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 189.39,
    y1: 129.6,
    x2: 105.48,
    y2: 277.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 104.01,
    y1: 279.95,
    x2: 103.77,
    y2: 280.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 143.34,
    y1: 332.65,
    x2: 192.67,
    y2: 226.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 156.26,
    y1: 192.1,
    x2: 193.7,
    y2: 274.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 193.08,
    y1: 191.23,
    x2: 156.53,
    y2: 191.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M26.15,183.82l26.31,37.98c.86,1.12.86,2.68,0,3.79l-28.34,36.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.84,286.81l59.23-.38c2.38-.02,3.89,2.53,2.73,4.61l-24.03,43.32c-1.15,2.08.36,4.63,2.74,4.61l59.84-.53c2.28-.02,3.81,2.35,2.84,4.42l-19.45,41.61c-.97,2.08.57,4.45,2.86,4.42l76.85-.57"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 192.88,
    y1: 333.06,
    x2: 141.2,
    y2: 333.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M21,178.31v-.13l.2-1.14.07.07c1.27-4.88,2.67-9.69,4.28-14.44,1.74-5.08,3.68-10.03,5.82-15.04,2.14-4.88,4.41-9.69,6.95-14.44,2.34-4.41,4.88-8.76,7.62-13.04l-6.35-4.14c-3.21,5.01-6.15,10.16-8.89,15.38-2.94,5.62-5.62,11.37-7.96,17.12-2.41,5.88-4.55,11.83-6.35,17.85-1.74,5.68-3.21,11.5-4.48,17.32l14.23,2.8c.4-1.88.82-3.76,1.26-5.62l-5.67-1.12-1-.2.07-.2h-.13l.27-1h.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M100.4,66.62c1.51-1.2,3.04-2.39,4.59-3.55l-.02-.03s0,0,0,0l-7.42-11.03c-4.95,3.48-9.69,7.09-14.31,10.9-4.81,4.08-9.49,8.36-13.91,12.77-4.41,4.48-8.69,9.16-12.64,13.97-3.81,4.61-7.35,9.36-10.76,14.24l6.35,4.21c2.88-4.08,5.88-8.16,9.03-12.1,3.34-4.14,6.89-8.16,10.56-12.03,3.68-3.88,7.55-7.62,11.63-11.16,3.74-3.41,7.69-6.62,11.7-9.69v-.07l.8-.53.13-.07.94-.73v.07h.07l.53.8,2.69,4.01s0,0,0,0l.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M356.33,314.37h26.74c13.96-25.18,21.91-54.15,21.91-84.98,0-93.42-72.96-169.8-165-175.27v382.7c-3.5.18-7.03.27-10.57.27-7.28,0-14.48-.38-21.57-1.11l-.7,3.54c4.95.67,9.89,1.14,14.84,1.4,5.35.33,10.63.4,15.91.27,5.28-.13,10.63-.47,15.91-1,3.2-.36,6.4-.81,9.59-1.32v2.4c-3.13.5-6.29.92-9.45,1.26-5.28.54-10.63.87-16.05,1-5.28.13-10.7.07-16.05-.27-5.08-.27-10.16-.73-15.24-1.47v.07l-.87-.2h-.13l-1.2-.13.07-.07h-.07l.2-1,.91-4.74c-1.91-.22-3.81-.46-5.7-.73l-2.56,13.03c5.89,1.07,11.83,1.87,17.78,2.41,6.28.54,12.57.8,18.85.8s12.57-.34,18.85-.94c3.55-.36,7.11-.81,10.66-1.33v2.43c-3.43.51-6.87.91-10.32,1.24-6.35.67-12.77.94-19.19,1-6.35,0-12.77-.27-19.19-.87-6.35-.53-12.77-1.41-19.05-2.61h-.2l-1-.2.2-1v-.2l2.75-14.12c-2.88-.45-5.74-.96-8.58-1.52l-2.99,15.37-.07.2-.2,1-.94-.2-.2-.07c-6.28-1.27-12.5-2.88-18.65-4.75-6.15-1.8-12.17-4.01-18.12-6.42-5.95-2.41-11.77-5.08-17.45-8.09-5.62-2.94-11.16-6.15-16.51-9.63l-.2-.13-.8-.53.54-.8.13-.2,5.62-8.49.53-.8.8.53.2.13c4.41,2.88,9.03,5.55,13.71,8.09,4.75,2.54,9.49,4.81,14.38,6.95,4.88,2.07,9.83,4.01,14.84,5.68,4.75,1.6,9.49,3.01,14.31,4.28l.84-4.43c-44.14-11.11-82.66-36.34-110.49-70.62l-3,2.04c3.08,4.01,6.22,7.82,9.49,11.5,3.54,3.95,7.22,7.76,11.03,11.43,3.88,3.68,7.89,7.22,12.03,10.5,4.15,3.34,8.42,6.55,12.84,9.49l.8.6-.07.13.13.07-.54.87-5.55,8.29-.07.2-.6.8-.8-.53-.2-.13c-5.28-3.61-10.43-7.42-15.31-11.43-4.95-4.08-9.69-8.36-14.24-12.9-4.55-4.48-8.89-9.23-12.97-14.17-4.08-4.88-8.02-10.03-11.63-15.31l-.13-.2-.6-.8.87-.6.13-.07,11.97-8.09c-1.72-2.35-3.39-4.73-5.01-7.16l-13.04,8.76-.13.13-.87.54-.54-.8-.07-.2h-.07c-3.48-5.35-6.75-10.83-9.83-16.51-3.01-5.68-5.75-11.43-8.22-17.38-2.47-5.88-4.68-11.9-6.62-17.98-1.87-6.08-3.54-12.3-4.88-18.59v-.13l-.27-1,1-.2.2-.07,9.96-2.01,1-.2.2,1v.2c1.14,5.15,2.47,10.3,4.01,15.38,1.54,5.15,3.28,10.16,5.22,15.11,2.01,4.95,4.14,9.76,6.48,14.57,2.21,4.41,4.55,8.76,7.09,13.04l3.75-2.51c-18.62-31.13-29.34-67.54-29.34-106.46,0-7.28.38-14.48,1.12-21.57l-3.54-.7c-.67,4.95-1.14,9.89-1.41,14.84-.33,5.35-.4,10.63-.33,15.91.13,5.28.53,10.63,1.07,15.91.6,5.28,1.4,10.56,2.41,15.78l.13,1h-.13v.2l-.94.2-9.76,2.01h-.2l-1,.2-.2-1-.07-.2c-1.21-6.22-2.07-12.57-2.74-18.92-.6-6.35-.94-12.77-.94-19.19s.27-12.77.8-19.19c.6-6.35,1.47-12.77,2.67-19.05v-.2l.2-1,1,.2h.2l14.11,2.75c.45-2.88.95-5.74,1.51-8.58l-15.36-2.99-.2-.07-1-.2.2-.94.07-.2c1.27-6.28,2.81-12.5,4.68-18.65,1.87-6.15,4.01-12.17,6.48-18.12,2.41-5.95,5.08-11.77,8.02-17.38,3.01-5.68,6.22-11.23,9.69-16.58l.07-.2.6-.8.8.54.2.13,8.42,5.62.87.53-.53.8-.13.2c-2.88,4.48-5.62,9.03-8.09,13.71-2.54,4.75-4.88,9.56-6.95,14.38-2.14,4.88-4.01,9.83-5.75,14.84-1.54,4.75-3.01,9.49-4.21,14.31l4.42.83c11.11-44.13,36.34-82.64,70.61-110.46l-.07-.09h0s-1.97-2.94-1.97-2.94c-4.01,3.08-7.82,6.22-11.5,9.49-4.01,3.54-7.82,7.22-11.43,11.03-3.68,3.88-7.22,7.89-10.56,12.03-3.34,4.15-6.48,8.42-9.43,12.84l-.6.8-.13-.07-.07.13-.87-.54-8.29-5.55-.2-.07-.8-.6.53-.8.13-.2c3.54-5.28,7.42-10.43,11.43-15.31,4.08-4.95,8.36-9.69,12.9-14.24,4.48-4.55,9.23-8.89,14.11-12.97,4.95-4.14,10.09-8.02,15.38-11.63l.2-.13.8-.6.53.87.13.13,8.07,11.95s0,0,0,0l.02.02c2.34-1.71,4.71-3.38,7.13-5v-.02s-.01,0-.01,0l-8.72-12.97-.13-.2-.53-.8.8-.6.2-.07c5.35-3.54,10.83-6.82,16.51-9.9,5.62-3.01,11.43-5.75,17.31-8.22,1.25-.52,2.51-1.02,3.76-1.52l.23-.09v-5.63C59.35,50.64,0,133.08,0,229.39c0,126.69,102.7,229.39,229.39,229.39,3.55,0,7.07-.08,10.57-.24,7.96-.36,15.81-1.12,23.53-2.28v-216.71h118.29c-1.81,27.58-10.94,53.17-25.47,74.83ZM263.5,216.11V80.47c63.75,14.54,112.32,68.97,118.06,135.64h-118.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M178.18,437.78l-.94-.2v-.07c-4.88-1.2-9.76-2.67-14.57-4.28-5.08-1.74-10.09-3.68-15.04-5.82-4.88-2.14-9.69-4.48-14.44-6.95-4.41-2.41-8.76-4.95-13.04-7.62l-4.21,6.35c5.01,3.21,10.23,6.15,15.44,8.89,5.62,2.94,11.3,5.55,17.12,7.96,5.88,2.41,11.83,4.48,17.85,6.35,5.68,1.74,11.5,3.21,17.32,4.41l2.79-14.17c-1.88-.4-3.75-.82-5.61-1.26l-1.12,5.68-.2,1-.2-.07v.07l-1-.27h-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M61.78,361.63l.8-.53,4.02-2.71c-1.2-1.51-2.38-3.03-3.54-4.58l-11.04,7.42c3.48,4.95,7.09,9.69,10.9,14.31,4.08,4.81,8.36,9.49,12.77,13.9,4.48,4.41,9.16,8.63,13.97,12.64,4.61,3.74,9.36,7.35,14.31,10.7l4.15-6.35c-4.08-2.81-8.16-5.82-12.03-8.96-4.21-3.34-8.22-6.89-12.1-10.63-3.88-3.68-7.56-7.49-11.16-11.57-3.41-3.74-6.62-7.69-9.69-11.77h-.07l-.53-.74-.07-.13-.73-.94h.07v-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M38.12,326.33c-2.41-4.81-4.61-9.69-6.55-14.71-2.01-4.95-3.74-10.03-5.28-15.18-1.47-4.81-2.74-9.63-3.81-14.57l-7.49,1.54c1.27,5.82,2.81,11.56,4.61,17.18,1.87,6.02,4.01,11.97,6.48,17.78,2.41,5.75,5.15,11.5,8.09,17.05,2.81,5.28,5.88,10.43,9.09,15.38l12.05-8.1c-1.04-1.6-2.07-3.21-3.07-4.84l-4.83,3.25-.8.53-.2-.27h-.07l-.47-.73-.07-.07-.53-.87h.07c-2.61-4.35-5.01-8.83-7.22-13.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M17.12,205.59l.13-.87.07-.34,1,.2,4.73.91c.22-1.91.47-3.81.74-5.7l-13.02-2.56c-1.07,5.89-1.87,11.83-2.41,17.78-.53,6.28-.87,12.57-.8,18.85,0,6.28.33,12.57.94,18.85.53,5.89,1.4,11.77,2.47,17.65l7.49-1.54c-.94-4.88-1.67-9.89-2.21-14.91-.53-5.28-.94-10.63-1.07-16.05-.07-5.28,0-10.7.33-16.05.27-5.01.73-10.03,1.4-15.04h-.07l.2-1.07.07-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M441.66,253.19l-.13,1.14h-.07v.07l-1-.2-4.72-.9c-.22,1.91-.47,3.81-.74,5.7l13.02,2.56c1.07-5.95,1.87-11.83,2.41-17.78.54-6.28.8-12.57.8-18.92s-.34-12.5-.94-18.79c-.6-5.88-1.4-11.77-2.47-17.65l-7.49,1.54c.94,4.88,1.67,9.9,2.21,14.91.54,5.28.87,10.63,1,15.98.13,5.35.07,10.76-.27,16.11-.27,5.08-.73,10.09-1.47,15.18l.07.07-.2.87v.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M217.71,404.58V22.02c3.86-.22,7.76-.33,11.68-.33,7.27,0,14.45.38,21.53,1.11l.67-3.53c-4.95-.67-9.9-1.14-14.77-1.41-5.35-.33-10.63-.4-15.91-.33-5.35.13-10.63.53-15.91,1.07-4.34.49-8.58,1.12-12.81,1.87v380.56c8.31,1.79,16.84,3,25.54,3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M437.27,281.46c-1.16,4.89-2.59,9.79-4.15,14.61-1.69,5.03-3.59,10.06-5.68,15.03-2.09,4.97-4.39,9.8-6.89,14.57-2.3,4.43-4.8,8.8-7.44,13.04l6.39,4.16c3.16-5.04,6.06-10.22,8.75-15.53,2.89-5.57,5.45-11.35,7.8-17.19,2.35-5.84,4.37-11.81,6.19-17.84,1.69-5.7,3.1-11.53,4.25-17.36l-13.87-2.59c-.4,1.88-.82,3.75-1.27,5.61l5.41,1.02,1,.19-.06.13.07.07-.26,1.01v.13s-.19.94-.19.94h-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M220.83,15.18c5.35-.07,10.76,0,16.11.33,5.01.27,10.03.73,15.04,1.4l.07-.07,1,.2.13.07.87.13.33.07-.2,1-.91,4.74c1.91.22,3.81.46,5.7.73l2.56-13.03c-5.95-1.07-11.83-1.87-17.78-2.41-6.28-.53-12.57-.87-18.92-.8-6.22,0-12.5.33-18.79.94-4.63.42-9.26,1.05-13.88,1.82v7.74c4.17-.74,8.43-1.35,12.68-1.81,5.28-.53,10.63-.94,15.98-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M420.67,132.45c2.4,4.75,4.55,9.69,6.55,14.71,1.94,4.95,3.74,10.03,5.28,15.18,1.47,4.75,2.74,9.63,3.81,14.57l7.49-1.54c-1.27-5.82-2.81-11.57-4.61-17.25-1.87-5.95-4.08-11.9-6.48-17.72-2.47-5.82-5.15-11.5-8.16-17.05-2.81-5.28-5.82-10.43-9.09-15.44l-12.01,8.12c1.05,1.61,2.08,3.23,3.09,4.87l4.84-3.23.8-.6.07.13h.07l.53.94h.07v.07l.53.8h-.07c2.61,4.35,5.08,8.82,7.29,13.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M296.18,25.07c5.08,1.67,10.09,3.61,15.04,5.75,4.88,2.14,9.76,4.48,14.44,7.02,4.41,2.34,8.76,4.88,13.04,7.62l4.21-6.35c-5.01-3.21-10.16-6.22-15.44-8.96-5.62-2.88-11.3-5.55-17.12-7.96-5.82-2.34-11.77-4.48-17.85-6.28-5.68-1.74-11.43-3.28-17.32-4.48l-2.84,14.71c1.87.39,3.74.82,5.59,1.26l1.19-6.21.2-.94h.2v-.07l1,.27h.13l.94.2v.07c4.95,1.27,9.76,2.67,14.57,4.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M392.17,100.38c1.19,1.5,2.36,3.01,3.51,4.54l11.01-7.45c-3.41-4.88-7.02-9.63-10.9-14.24-4.01-4.81-8.29-9.49-12.77-13.91-4.41-4.41-9.09-8.69-13.97-12.63-4.55-3.81-9.29-7.35-14.24-10.77l-4.21,6.35c4.15,2.88,8.16,5.88,12.1,9.03,4.15,3.34,8.22,6.89,12.1,10.56s7.56,7.55,11.16,11.63c3.34,3.74,6.55,7.62,9.63,11.7l.07-.07.6.87.07.07v.07l.67.87h-.07l.07.13-.8.53-4.03,2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M310.75,425.01c4.95-1.94,9.76-4.08,14.57-6.42,4.42-2.2,8.76-4.61,13.04-7.09l-2.51-3.74c-8.67,5.18-17.75,9.76-27.18,13.65v4.37h.03c.68-.26,1.37-.51,2.04-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M308.68,436.45h.02c3.25-1.18,6.48-2.43,9.67-3.75,5.76-2.48,11.5-5.15,17.05-8.16,5.28-2.81,10.43-5.81,15.37-9.09l-8.06-12c-1.6,1.05-3.23,2.07-4.86,3.07l3.23,4.84.53.8-.07.07v.07l-.93.53-.07.07-.8.53v-.07c-4.42,2.61-8.89,5.08-13.44,7.29-4.81,2.41-9.69,4.55-14.71,6.55-.96.38-1.94.75-2.92,1.11h0s-.02,0-.02,0v8.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M229.4,0c-12.67,0-25.11,1.02-37.22,3.01v4.86c4.5-.73,9.02-1.31,13.55-1.79,6.35-.6,12.77-.93,19.12-.93s12.84.27,19.19.8c6.42.6,12.77,1.47,19.12,2.67h.2l1,.2-.2,1-.07.2-2.74,14.1c2.89.45,5.76.96,8.61,1.53l3.1-15.9.07-.2.2-.94,1,.2h.2c6.28,1.27,12.5,2.87,18.59,4.74,6.15,1.88,12.16,4.01,18.12,6.42,5.95,2.4,11.77,5.15,17.45,8.08,5.68,2.94,11.16,6.22,16.51,9.63l.2.13.87.54-.6.86-.06.14-5.62,8.49-.6.81-.8-.54-.13-.06c-4.48-2.94-9.1-5.62-13.77-8.16-4.68-2.47-9.49-4.81-14.38-6.89-4.88-2.14-9.83-4.01-14.84-5.75-4.68-1.6-9.43-3.01-14.24-4.21l-.96,4.9c44.12,11.1,82.62,36.32,110.44,70.57l2.97-1.99c-3.01-4.01-6.15-7.82-9.43-11.49-3.55-4.01-7.22-7.82-11.03-11.44-3.87-3.68-7.89-7.22-12.03-10.56-4.14-3.34-8.43-6.48-12.84-9.49l-.8-.54.07-.13-.14-.14.53-.8,5.55-8.29.06-.2.54-.8.87.53.13.13c5.35,3.55,10.43,7.42,15.37,11.43,4.95,4.08,9.7,8.36,14.24,12.9,4.55,4.48,8.89,9.23,12.97,14.11,4.07,4.95,7.95,10.1,11.63,15.38l.14.2.53.8-.81.53-.2.13-11.92,8.06c1.72,2.35,3.4,4.73,5.02,7.16l12.99-8.73.2-.14.8-.53.6.81.07.2c3.55,5.35,6.82,10.83,9.83,16.51,3.07,5.61,5.81,11.43,8.29,17.32,2.47,5.95,4.68,11.97,6.55,18.05,1.94,6.08,3.55,12.3,4.95,18.52v.2l.2,1.01-1.01.2-.13.07-9.96,2.01-1.01.2-.2-1-.07-.2c-1.07-5.21-2.4-10.36-3.94-15.44-1.54-5.08-3.34-10.1-5.28-15.04-1.94-4.95-4.08-9.83-6.41-14.57-2.2-4.42-4.61-8.83-7.09-13.04l-3.76,2.51c18.62,31.13,29.34,67.54,29.34,106.46,0,7.28-.38,14.47-1.12,21.57l3.55.7c.66-5.02,1.14-9.96,1.4-14.84.33-5.35.4-10.63.27-15.92-.14-5.35-.47-10.63-1.01-15.91-.6-5.35-1.4-10.56-2.4-15.78l-.2-1h.2l-.07-.2,1-.2,9.76-2.01h.2l1-.2.2.93v.2c1.27,6.28,2.14,12.64,2.74,18.98.67,6.35.94,12.77,1,19.13,0,6.41-.27,12.84-.87,19.19-.53,6.41-1.4,12.77-2.6,19.12v.2l-.2,1.01-1-.2-.2-.06-14.1-2.74c-.45,2.91-.97,5.8-1.53,8.67l15.05,2.79.2.06,1.01.13-.19,1-.06.2c-1.22,6.3-2.76,12.52-4.58,18.69-1.75,6.17-3.91,12.21-6.25,18.18-2.35,5.97-4.97,11.75-7.94,17.46-2.89,5.71-6.05,11.28-9.48,16.67l-.13.14-.53.87-.81-.53-.2-.13-8.54-5.54-.81-.53.53-.81.14-.2c2.83-4.51,5.46-9.08,7.96-13.78,2.5-4.77,4.73-9.61,6.82-14.51,2.02-4.83,3.92-9.8,5.55-14.89,1.56-4.69,2.92-9.46,4.15-14.28l-4.17-.78c-11.11,44.13-36.33,82.64-70.6,110.47l2.01,2.95c4.01-3.01,7.82-6.15,11.5-9.43,3.95-3.55,7.76-7.22,11.43-11.03,3.68-3.88,7.22-7.89,10.5-12.03,3.34-4.15,6.55-8.43,9.49-12.84l.6-.81.13.07.07-.14.87.54,8.29,5.48.2.14.8.53-.53.87-.13.14c-3.61,5.35-7.42,10.43-11.44,15.37-4.07,4.95-8.35,9.69-12.9,14.24-4.48,4.55-9.23,8.82-14.18,12.97-4.88,4.08-10.03,7.95-15.31,11.63l-.2.14-.8.53-.6-.8-.07-.2-8.05-11.92c-2.35,1.71-4.74,3.38-7.16,5l8.72,12.99.13.2.54.8-.8.6-.2.07c-5.35,3.54-10.83,6.82-16.51,9.82-5.68,3.07-11.43,5.82-17.39,8.29-3.46,1.46-6.98,2.81-10.52,4.07h0s0,0,0,0c0,0,0,0-.01,0h0s-.02,0-.02,0v5.73c87.62-32.27,150.1-116.49,150.1-215.31C458.79,102.7,356.09,0,229.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M362.64,396.33l-.67.47-.33.2-.53-.87-2.71-3.96c-1.5,1.19-3.02,2.36-4.56,3.52l7.4,11c4.95-3.41,9.69-7.02,14.31-10.9,4.81-4.01,9.49-8.29,13.9-12.77,4.41-4.41,8.63-9.09,12.64-13.97,3.74-4.55,7.35-9.29,10.7-14.24l-6.35-4.21c-2.81,4.15-5.82,8.16-8.96,12.1-3.34,4.15-6.89,8.22-10.63,12.1-3.68,3.81-7.49,7.56-11.57,11.16-3.74,3.34-7.69,6.55-11.7,9.63l.07.07-.87.6-.13.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M143.23,35.73c-3.31,1.4-6.57,2.88-9.78,4.46-4.41,2.21-8.83,4.55-13.04,7.09l2.5,3.74c-.67.4-1.34.81-2.01,1.22l-3.24-4.82-.6-.8.13-.07v-.07l.94-.6.07-.07.87-.53v.07c4.34-2.61,8.82-5.01,13.37-7.22,3.5-1.78,7.12-3.4,10.78-4.94l.23-.1v-8.15l-.29.04c-.92.37-1.85.73-2.77,1.11-5.82,2.47-11.5,5.15-17.05,8.09-5.28,2.81-10.43,5.88-15.44,9.16l8.13,11.97s0,0,0,0v.02c8.72-5.68,17.87-10.73,27.42-15.07v-4.56l-.23.04Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M610.51,395.42h-104.5V95.61h24.41v277.11h80.09v22.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M695.91,131.16c0,32.98-3,38.12-24.84,41.54l-3.85-11.14c12.42-2.14,14.13-5.14,14.13-25.7v-8.99h-11.99v-31.27h26.55v35.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M858.83,395.42l-13.28-83.95h-57.39l-13.28,83.95h-24.41c0-.86.43-2.14.43-2.14l50.11-297.66h31.27l50.54,297.66c.43,0,.43,1.28.43,2.14h-24.41ZM816.43,128.16l-25.27,161.89h50.97l-25.7-161.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1045.31,184.27c0-26.13-4.71-29.55-37.69-29.55s-35.98,3.85-35.98,30.84v209.86h-23.13V138.44h23.13v6.85c6.42-9.42,19.27-11.14,44.11-11.14,45.83,0,52.25,5.57,52.25,44.97v41.12h-23.13s.43-20.13.43-35.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1274.62,352.59c0,41.54-7.28,47.11-59.53,47.11s-59.53-5.57-59.53-46.68v-193.16h-37.26v-21.41h37.26v-17.13c14.13,0,15.85-3.43,15.85-29.98h7.28v47.11h82.23v21.41h-82.23v194.44c0,22.27,4.28,25.27,36.4,25.27s36.83-3,36.83-25.27-.43-50.97-.43-50.97h23.13v49.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1337.75,395.42V95.61h23.13v50.11c6.85-9.85,20.13-11.56,45.83-11.56,48.4,0,54.82,5.57,54.82,44.97v175.17c0,39.83-6.42,45.4-54.82,45.4-25.7,0-38.97-2.14-45.83-11.99v7.71h-23.13ZM1360.87,347.88c0,28.7,4.71,32.55,37.69,32.55,35.12,0,39.83-3.85,39.83-31.69v-164.46c0-26.13-4.71-29.55-39.83-29.55-32.98,0-37.69,3.85-37.69,30.84v162.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1534.5,178.7c0-39.4,6.85-44.54,58.68-44.54,58.68,0,59.53,5.14,59.53,44.54v216.72h-23.13v-11.56c-5.57,13.28-17.99,15.85-46.26,15.85-44.97,0-50.97-5.57-50.97-44.97v-52.25c0-33.84,6-39.4,51.4-44.97,39.83-4.71,45.4,1.71,45.4-28.27h.43v-53.96c0-18.42-1.28-20.99-35.98-20.99-30.84,0-35.12,2.57-35.12,20.99,0,21.84-.43,49.68-.43,49.68h-23.13l-.43-46.26ZM1629.15,267.79c-6.85,5.14-19.7,3.43-43.69,6.42-26.55,3.43-29.98,6.85-29.98,28.27,0,43.26-.43,47.11-.43,47.11-.43,26.55,4.28,29.98,37.26,29.98s36.83-3.43,36.83-29.98h.43v-81.8h-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1827.2,395.42v-1.28c0-17.13.43-123.35.43-209.86,0-26.13-4.71-29.55-39.4-29.55s-38.12,3.85-38.12,30.84v209.86h-23.13V138.44h23.13v7.28c6.85-9.85,20.13-11.56,45.83-11.56,47.97,0,54.39,5.57,54.39,44.97v216.29h-23.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2024.39,395.42v-1.28c0-17.13.43-123.35.43-209.86,0-26.13-4.71-29.55-39.4-29.55s-38.12,3.85-38.12,30.84v209.86h-23.13V138.44h23.13v7.28c6.85-9.85,20.13-11.56,45.83-11.56,47.97,0,54.39,5.57,54.39,44.97v216.29h-23.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2244.7,352.59c0,41.54-7.28,47.11-61.67,47.11s-61.67-5.57-61.67-46.68v-172.6c0-40.69,7.28-46.26,61.67-46.26s61.67,5.57,61.67,46.26v80.95h-100.65v92.94c0,22.27,4.71,25.27,38.97,25.27s38.97-3,38.97-25.27c0-24.41-.43-55.25-.43-55.25h23.13v53.54ZM2221.57,180.41c0-23.13-4.71-26.13-38.55-26.13s-38.97,3-38.97,25.7v61.25h77.52v-60.82Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoArtbanneLongBlanc);
export default __webpack_public_path__ + "static/media/Logo_Artbanne_long_blanc.53aff6b91b5d4ae52eccf8a145f162a2.svg";
export { ForwardRef as ReactComponent };